import {useRef, useState} from 'react'

import Style from './style'
import eraseIcon from 'shared/assets/erase.svg'
import MainHeader from 'widget/MainHeader'

import useGetStoreTicketTypes from 'entity/store/useGetStoreTicketTypes'

import useVoucherTypeEvent from '../../../entity/store/useVoucherTypeEvent'
import useVoucherType from '../../../entity/store/useVoucherType'

import CStyle from 'shared/style/commonStyle'
import DefaultButton from 'shared/ui/DefaultButton'

const MyFranchiseTicketEdit = () => {
	const [ticketTypes, ticketTypesLoading, refetchTicketTypes] =
		useGetStoreTicketTypes()

	const {
		voucherTypeList,
		updateVoucherName,
		updateVoucherExpiration,
		addNewVoucher,
		removeVoucher,
	} = useVoucherTypeEvent(ticketTypes?.data?.ticket_types)

	const [processVoucherChanges, voucherProcessing] = useVoucherType()

	const [isSubmitting, setIsSubmitting] = useState(false)

	const handleNameChange = (e, index) => {
		updateVoucherName(index, e.target.value)
	}

	const handleExpirationChange = (e, index) => {
		const value =
			e.target.value === 'unlimited' ? null : parseInt(e.target.value)
		updateVoucherExpiration(index, value)
	}

	const handleSubmit = async () => {
		setIsSubmitting(true)
		try {
			const voucherUpdateSuccess = await processVoucherChanges(
				ticketTypes?.data?.ticket_types,
				voucherTypeList
			)

			if (voucherUpdateSuccess) {
				await refetchTicketTypes()
			}
		} catch (error) {
			console.error('Submit error:', error)
		} finally {
			setIsSubmitting(false)
		}
	}

	const btnList = [
		{
			label: '저장',
			clickEvent: handleSubmit,
			deactive: isSubmitting || ticketTypesLoading || voucherProcessing,
		},
	]

	return (
		<Style.Wrapper>
			<MainHeader btnList={btnList} title='매장 매장 이용권 수정' />

			{/* 매장 이용권 유형 목록 */}
			<Style.AreaDiv>
				<Style.AreaHeader>
					<h2>
						매장 이용권 유형 목록<span>*</span>
					</h2>
					<DefaultButton
						small
						fitWidth
						clickEvent={addNewVoucher}
						deactive={isSubmitting}
					>
						항목 추가
					</DefaultButton>
				</Style.AreaHeader>
				<CStyle.GuideDiv>
					<p>
						이것은 매장에서 진행하는 게임이나 콘테스트에 참여하기 위해 발급되는
						매장 이용권 유형입니다.
					</p>
					<ul>
						<li>
							여기 나열된 매장 이용권 유형만 매장에서 진행하는 이벤트나 챌린지의
							상품으로 지급될 수 있습니다.
						</li>
						<li>
							여기 나열된 매장 이용권만 매장 콘테스트나 게임 세션에 참여할 때
							사용할 수 있습니다.
						</li>
					</ul>
					<p>
						기존 매장 이용권 유형의 이름은 변경할 수 있지만, 최소 1개의 매장
						이용권 유형은 유지되어야 합니다.
					</p>
				</CStyle.GuideDiv>

				<Style.TableDiv>
					{voucherTypeList.map((voucher, index) => (
						<Style.VoucherItem key={voucher.idx || `new-${index}`}>
							<Style.VoucherRow>
								<Style.VoucherLabel>
									매장 이용권 유형<span>*</span>
								</Style.VoucherLabel>
								<Style.VoucherInput>
									<input
										onChange={(e) => handleNameChange(e, index)}
										value={voucher.name || ''}
										placeholder='유형을 입력하세요'
										disabled={isSubmitting}
									/>
								</Style.VoucherInput>
							</Style.VoucherRow>

							<Style.VoucherRowRight>
								<Style.VoucherLabel>만료 시간</Style.VoucherLabel>
								<Style.VoucherExpiration>
									<Style.RadioGroup>
										<Style.RadioOption>
											<input
												type='radio'
												name={`expiration_${index}`}
												value='30'
												checked={voucher.expiration_days === 30}
												onChange={(e) => handleExpirationChange(e, index)}
												disabled={isSubmitting}
											/>
											<label>30 days</label>
										</Style.RadioOption>
										<Style.RadioOption>
											<input
												type='radio'
												name={`expiration_${index}`}
												value='60'
												checked={voucher.expiration_days === 60}
												onChange={(e) => handleExpirationChange(e, index)}
												disabled={isSubmitting}
											/>
											<label>60 days</label>
										</Style.RadioOption>
										<Style.RadioOption>
											<input
												type='radio'
												name={`expiration_${index}`}
												value='unlimited'
												checked={voucher.expiration_days === null}
												onChange={(e) => handleExpirationChange(e, index)}
												disabled={isSubmitting}
											/>
											<label>Unlimited</label>
										</Style.RadioOption>
										<button
											onClick={() => removeVoucher(index)}
											disabled={voucherTypeList.length <= 1 || isSubmitting}
										>
											<img src={eraseIcon} alt='삭제' />
										</button>
									</Style.RadioGroup>
								</Style.VoucherExpiration>
							</Style.VoucherRowRight>
						</Style.VoucherItem>
					))}
				</Style.TableDiv>
			</Style.AreaDiv>
		</Style.Wrapper>
	)
}

export default MyFranchiseTicketEdit
